<template>
    <div class="card card-body shadow">
        <owl-data-grid class="table table-striped" url="usulan-list" :columns="this.columns" :dataCounts="[9, 3 * 9, 9 * 9]" @set-datas="(data) => datas = data">
            <div class="col-12 col-md-4" v-for="data in datas" v-bind:key="data">
                <router-link :to="{ name: this.redirectTo[data.status], params: { id: data.id } }">
                    <div class="card card-body mb-3 shadow">
                        <div class="d-flex justify-content-between">
                            <div class="h3 text-truncate"> {{ data.kode_sampel }}</div>
                            <div class="h6 text-truncate fw-light"> {{ data.r_pengajuan.tanggal }}</div>
                        </div>
                        <div class="h6 text-truncate">Nomer Tracking : {{ data.r_pengajuan.kode_tracking }}</div>
                        <div class="h6 text-truncate">Pemohon : {{ data.r_pengajuan.nama }} ({{ data.r_pengajuan.instansi }})</div>
                        <div class="h6 text-truncate">{{ data.r_kategori.nama }} | {{ data.r_sub_kategori.nama }}</div>
                        <small>Status: {{ data.status }}</small>
                    </div>
                </router-link>
            </div>
        </owl-data-grid>
    </div>
</template>

<script>
import OwlDataGrid from '@/components/OwlDataGrid.vue';

export default {
    name: "UjilabPengujianIndex",
    components: { OwlDataGrid },
    data() {
        return {
            datas: {},
            redirectTo: {
                'Diterima': 'ujilab.pengujian.form-pengujian',
                'Menunggu Antrian': 'ujilab.pengujian.form-proses',
                'Proses Pengujian': 'ujilab.pengujian.form-upload',
                'Proses Analisis Data': 'ujilab.pengujian.form-upload',
            },
            columns: [
                {
                    data: 'Kode Sampel',
                    name: 'kode_sampel',
                    orderable: true
                },
                {
                    data: 'Tanggal',
                    name: 'tanggal',
                    orderable: true
                },
            ]
        }
    },
}
</script>